/*
 * @FileName       : reports.actions.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action class for reports.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { action } from 'typesafe-actions';

import { REPORTS } from '../constants/actions';
import {
	InventoryFilter,
	InventoryGroup,
	InventoryDetail,
	RecentlyVended,
	TransactionLogFilter,
	ReportFilter,
} from '../models/reports/Inventory';
import { ResultSet } from '../models/common/result.set';

export const getInventoryGroup = (data: InventoryFilter) => action(REPORTS.INVENTORY.GROUP.REQUEST, data);
export const successInventoryGroup = (data: ResultSet<InventoryGroup>) => action(REPORTS.INVENTORY.GROUP.SUCCESS, data);
export const clearInventoryGroup = () => action(REPORTS.INVENTORY.GROUP.CLEAR_LIST, {});

export const getInventoryHistory = (data: any) => action(REPORTS.INVENTORY.HISTORY.LIST, data);
export const successInventoryHistory = (data: any) => action(REPORTS.INVENTORY.HISTORY.LIST_RESPONSE, data);

export const getDispensedProducts = (data: any) => action(REPORTS.DISPENSED.GET, data);
export const setDispensedProducts = (data: any) => action(REPORTS.DISPENSED.SET, data);

export const getWarehouseShipments = (data: any) => action(REPORTS.SHIPMENTS.GET, data);
export const setWarehouseShipments = (data: any) => action(REPORTS.SHIPMENTS.SET, data);

export const getCurrentInventory = (data: InventoryFilter) => action(REPORTS.INVENTORY.CURRENT.LIST, data);
export const successCurrentInventory = (data: InventoryDetail) => action(REPORTS.INVENTORY.CURRENT.LIST_RESPONSE, data);

export const getRecentlyVended = (data: TransactionLogFilter) => action(REPORTS.INVENTORY.USAGE.LIST, data);
export const clearRecentlyVended = () => action(REPORTS.INVENTORY.USAGE.CLEAR_USAGE_LIST, {});

export const successRecentlyVended = (data: ResultSet<RecentlyVended>) =>
	action(REPORTS.INVENTORY.USAGE.LIST_RESPONSE, data);

export const transactionLogExport = (data: TransactionLogFilter) => action(REPORTS.INVENTORY.USAGE.EXPORT, data);
export const getTransactionGroupLog = (data: any) => action(REPORTS.INVENTORY.USAGE.GET_GROUP, data);
export const setTransactionGroupLog = (groupData: any) => action(REPORTS.INVENTORY.USAGE.SET_GROUP, groupData);
export const setTransactionGroupNames = (groupNames: any) =>
	action(REPORTS.INVENTORY.USAGE.SET_GROUP_NAMES, groupNames);

export const fixTableColumn = (data: any) => action(REPORTS.INVENTORY.CURRENT.FIX_COLUMNS, data);
export const fixTableColumnSuccess = (data: any) => action(REPORTS.INVENTORY.CURRENT.FIX_COLUMNS_SUCCESS, data);

export const setFilter = (data: ReportFilter) => action(REPORTS.INVENTORY.GROUP.REPORT_FILTER, data);
export const setFilterSuccess = (data: ReportFilter) => action(REPORTS.INVENTORY.GROUP.REPORT_FILTER_SUCCESS, data);

export const clearGlobalData = () => action(REPORTS.CLEAR_GLOBAL_DATA);

export const getRestockOrderDetails_igShipmentItems = (orderId: string) =>
	action(REPORTS.RESTOCK_ORDER_DETAILS.IG_SHIPMENT_ITEMS, orderId);
export const getRestockOrderDetails_restockRequest = (orderId: string) =>
	action(REPORTS.RESTOCK_ORDER_DETAILS.RESTOCK_REQUEST, orderId);
export const getRestockOrderDetails_warehouseShipment = (orderId: string) =>
	action(REPORTS.RESTOCK_ORDER_DETAILS.WAREHOUSE_SHIPMENT, orderId);
export const getRestockOrderDetails_transactions = (orderId: string) =>
	action(REPORTS.RESTOCK_ORDER_DETAILS.TRANSACTIONS, orderId);
export const getRestockOrderDetails_sapOrders = (orderId: string) =>
	action(REPORTS.RESTOCK_ORDER_DETAILS.SAP_ORDERS, orderId);

export const setRestockOrderDetails_igShipmentItems = (data: any) =>
	action(REPORTS.SET_RESTOCK_ORDER_DETAILS.IG_SHIPMENT_ITEMS, data);
export const setRestockOrderDetails_restockRequest = (data: any) =>
	action(REPORTS.SET_RESTOCK_ORDER_DETAILS.RESTOCK_REQUEST, data);
export const setRestockOrderDetails_warehouseShipment = (data: any) =>
	action(REPORTS.SET_RESTOCK_ORDER_DETAILS.WAREHOUSE_SHIPMENT, data);
export const setRestockOrderDetails_transactions = (data: any) =>
	action(REPORTS.SET_RESTOCK_ORDER_DETAILS.TRANSACTIONS, data);
export const setRestockOrderDetails_sapOrders = (data: any) =>
	action(REPORTS.SET_RESTOCK_ORDER_DETAILS.SAP_ORDERS, data);

export const getCycleCounts = (data: any) => action(REPORTS.CYCLE_COUNTS.GET, data);
export const setCycleCounts = (data: any) => action(REPORTS.CYCLE_COUNTS.SET, data);
